import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'

import { IPincodesList } from './types'

export const getPincodeSuggestions = async (pincodeInput: string) => {
  try {
    const { data } = await zetApi.request<IPincodesList>({
      url: ENDPOINTS[APP_NAME].getPincodeSuggestions.endpoint,
      method: ENDPOINTS[APP_NAME].getPincodeSuggestions.method,
      params: {
        input: pincodeInput,
      },
    })
    // const { data } = await zetApi.get<IPincodesList>(
    //   `user/pincode/suggest?input=${pincodeInput}`
    // )
    return (
      data?.data?.pincodes?.map((pincode: { code: string }) => pincode.code) ||
      []
    )
  } catch (error) {
    console.log('SUGGESTED-PINCODE-ERROR', error)
  }
}

export const getRecentPincodes = async () => {
  try {
    const { data } = await zetApi.get<IPincodesList>(`user/pincode/recent`)
    return (
      data?.data?.pincodes?.map((pincode: { code: string }) => pincode.code) ||
      []
    )
  } catch (error) {
    console.log('RECENT-PINCODE-ERROR', error)
  }
}
